import { FC } from 'react';
import { InputNumber } from '../shared/form/InputNumber';
import { SMILES_NUMBER_MAX_LENGTH, SMILES_NUMBER_MIN_LENGTH } from '../../constants/form';
import { SmilesData } from './useSmiles';
import { FormTitle } from './FormTitle';

type Props = {
  smilesData: SmilesData;
  customRef?: (ref: HTMLParagraphElement | null) => void;
};

export const FormularioSmiles: FC<Props> = ({ smilesData, customRef }) => {
  return (
    <>
      <FormTitle aria-label="Ingresá un número Smiles Argentina." ref={customRef}>
        Ingresá un N° Smiles Argentina
      </FormTitle>
      <InputNumber
        placeholder="ej.: 123456789"
        name="clientNumber"
        required={true}
        formRegister={smilesData.register}
        errorCollection={smilesData.errors}
        minLength={SMILES_NUMBER_MIN_LENGTH}
        maxLength={SMILES_NUMBER_MAX_LENGTH}
      />
    </>
  );
};
